import { render, staticRenderFns } from "./PrizeAllPicture.vue?vue&type=template&id=1ad8de2a&scoped=true&"
import script from "./PrizeAllPicture.vue?vue&type=script&lang=js&"
export * from "./PrizeAllPicture.vue?vue&type=script&lang=js&"
import style0 from "./PrizeAllPicture.vue?vue&type=style&index=0&id=1ad8de2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad8de2a",
  null
  
)

export default component.exports